import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { DiaSemanaNumero } from "core/features/area-comum/typings";
export interface SelectDiaSemanaProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  filterOptions?: number[];
}

function SelectDiaSemana({
  value,
  filterOptions = [],
  ...rest
}: SelectDiaSemanaProps) {
  const options = [
    {
      label: "Domingo",
      value: DiaSemanaNumero.Domingo.toString(),
    },
    {
      label: "Segunda-feira",
      value: DiaSemanaNumero.Segunda.toString(),
    },
    {
      label: "Terça-feira",
      value: DiaSemanaNumero.Terca.toString(),
    },
    {
      label: "Quarta-feira",
      value: DiaSemanaNumero.Quarta.toString(),
    },
    {
      label: "Quinta-feira",
      value: DiaSemanaNumero.Quinta.toString(),
    },
    {
      label: "Sexta-feira",
      value: DiaSemanaNumero.Sexta.toString(),
    },
    {
      label: "Sábado",
      value: DiaSemanaNumero.Sabado.toString(),
    },
  ];

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      defaultValue={null}
      options={options.filter(
        (option) => !filterOptions.includes(Number(option.value))
      )}
      {...rest}
    />
  );
}

export default SelectDiaSemana;
